<template>
    <v-card :width="width" class="mt-0 mb-3 card-style" :class="{ 'card-style-active': isClicked }" @click.prevent.stop="readContent(type, idx)">
      <v-img :src="thumbnailSrc" :aspect-ratio="16/9">
        <v-layout justify-center align-center fill-height v-if="type === 'video'">
          <img src="@/assets/img/play-video.png" style="width: 48px; height: 48px;">
        </v-layout>
      </v-img>
      <v-card-title primary-title class="pa-3 text-xs-left align-start" style="min-height: 72px;">
        <span v-if="subtitle" :style="{ 'color': subtitle_color }"
              style="font-size: 14px; letter-spacing: -0.2px; font-weight: 700; width: 100%;">{{ subtitle }}</span>
        <span class="card-title" :style="{ WebkitLineClamp: subtitle ? 1 : 2 }">{{ title }}</span>
      </v-card-title>
    </v-card>
</template>

<script>
  export default {
    name: 'ContentCard',
    props: [ 'width', 'idx', 'type', 'thumbnail', 'title', 'subtitle', 'subtitle_color', 'video_id' ],
    data () {
      return {
        isClicked: false,
      };
    },
    computed: {
      thumbnailSrc () {
        if (this.type === 'video') {
          return `https://i.ytimg.com/vi/${this.video_id}/hqdefault.jpg`;
        } else if (this.thumbnail) {
          return `${this.$storage}/${this.storageType}/${this.thumbnail}`;
        }
        return require('@/assets/img/thumbnail-default.png');
      },
      storageType () {
        return this.type === 'store' ? 'store' : 'post';
      },
    },
    methods: {
      readContent (type, idx) {
        this.isClicked = true;
        window.setTimeout(() => {
          switch (type) {
            case 'video':
              this.$router.push({ name: 'ReadVideo', params: { idx } });
              break;
            case 'content':
              this.$router.push({ name: 'ReadContent', params: { idx } });
              break;
            case 'store':
              this.$router.push({ name: 'ReadProduct', params: { idx } });
              break;
            default:
              break;
          }
        }, 200);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-style {
    position: relative;
    border-radius: 5px !important;
    box-shadow: 0 10px 10px rgba(#9b9b9b, 0.25) !important;
    &-active {
      transform: scale(0.98);
      box-shadow: 0 5px 5px rgba(#9b9b9b, 0.25) !important;
    }
  }

  .card-title {
    word-break: keep-all;
    word-wrap: break-word;

    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.2px;
    color: map_get($colors, charcoal);

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

</style>
